import { useSearchParams } from 'next/navigation';
import { useIntl } from 'react-intl';

import PlanSkuToggle from '@/components/purchase/PlanSkuToggle';
import PurchaseDetails from '@/components/purchase/PurchaseDetails';
import { CalendarUnits } from '@/components/purchase/utils/Purchase';
import secondFreeTrialMessages from '@/components/secondFreeTrial/messages';
import { useDeviceState, usePricesState, usePurchaseParamsState, useUserState } from '@/hooks/store';
import isUSPricing from '@/utils/prices/isUSPricing';
import { userCanTrial } from '@/utils/subscriptions';

import messages from './messages';
import { Divider, Heading, HeadingContainer, OrderSummary, Subheading } from './styles';

type PaymentFormHeadingProps = {
	isSecondFreeTrial?: boolean;
	hideOrderSummary?: boolean;
};

const PaymentFormHeading = ({ isSecondFreeTrial, hideOrderSummary = false }: PaymentFormHeadingProps) => {
	const { isMobile, ...device } = useDeviceState();
	const { purchaseType, plan } = usePurchaseParamsState();
	const user = useUserState();
	const prices = usePricesState();
	const isUS = isUSPricing(prices, device);
	const { formatMessage } = useIntl();
	const searchParams = useSearchParams();
	const isOrganicTraffic =
		searchParams?.get('utm_medium') !== 'paid' && searchParams?.get('focus') !== 'second_free_trial';

	// TODO: this wasn't changed
	const buildHeading = () => {
		if (isSecondFreeTrial) {
			return formatMessage(secondFreeTrialMessages.sharedPaymentHeader);
		}
		if (!userCanTrial(user) || plan === 'monthly') {
			return <Heading>{formatMessage(messages.getCalm)}</Heading>;
		}
		const message =
			purchaseType?.units === CalendarUnits.DAYS ? messages.trialDayHeading : messages.trialMonthHeading;

		return formatMessage(message, {
			amount: purchaseType?.duration,
			quantity: purchaseType?.duration,
			br: isMobile ? <br /> : '',
		});
	};

	return (
		<>
			<HeadingContainer>
				<Heading tabIndex={-1}>{buildHeading()}</Heading>
				{!isSecondFreeTrial && <Subheading>{formatMessage(messages.preheading)}</Subheading>}
			</HeadingContainer>
			{!hideOrderSummary && (
				<>
					<Divider />
					<OrderSummary>
						{isUS && isOrganicTraffic ? (
							<PlanSkuToggle hideCount={true} />
						) : (
							<PurchaseDetails isSecondFreeTrial={isSecondFreeTrial} isOrganicTraffic={isOrganicTraffic} />
						)}
					</OrderSummary>
				</>
			)}
		</>
	);
};

export default PaymentFormHeading;
